import React, { useContext } from 'react'

import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Menu, Header, Image } from 'semantic-ui-react'

import ProjectsIcon from '../../_images/menu-projects-icon.svg'
import DatasetsIcon from '../../_images/menu-datasets-icon.svg'
import IntegrationsIcon from '../../_images/menu-integrations-icon.svg'
import TeamIcon from '../../_images/menu-team-icon.svg'
import BrandingIcon from '../../_images/menu-branding-icon.svg'
import SubscriptionIcon from '../../_images/menu-subscription-icon.svg'
import LogoutIcon from '../../_images/menu-logout-icon.svg'
import HelpCentreIcon from '../../_images/menu-help-centre-icon.svg'
import AdminIcon from '../../_images/menu-admin-icon.svg'

import VloggiLogoWhite from '../../_images/vloggi-logo-white.png'
import VloggiSmallLogoWhite from '../../_images/vloggi-small-logo-white.png'

import { UserContext } from '../../contexts/UserContext'

import Auth from '../../utils/Auth'

import MenuItem from './MenuItem'
import TrialProgressBar from './TrialProgressBar'

const userMenuItems = [
  { name: 'Projects', page: 'projects', icon: ProjectsIcon },
  //{ name: 'Video Templates', page: 'themes', icon: ThemesIcon },
  { name: 'Datasets', page: 'datasets', icon: DatasetsIcon },
  { name: 'Integrations', page: 'my-integrations', icon: IntegrationsIcon },
  { name: 'Team', page: 'my-team', icon: TeamIcon },
  { name: 'Branding', page: 'my-branding', icon: BrandingIcon },
  { name: 'Subscription', page: 'my-account', icon: SubscriptionIcon },
  { name: 'Logout', page: 'logout', icon: LogoutIcon },
  { name: 'Help Center', page: 'help-centre', icon: HelpCentreIcon },
]

const adminMenuItems = [
  { name: 'Admin (admin only)', page: 'admin', icon: AdminIcon }
]

const SideBarMain = ({ history, location, isSmallSideBar = false, goToPage }: IProps) => {
  const { userProfile, dispatchUserContext } = useContext(UserContext)

  const logout = () => {
    dispatchUserContext({ type: 'log out' })
    history.push('/login')
  }

  // in case the userProfile could not be fetched, log out the user
  if (!userProfile) {
    logout()
    return null
  }

  const { teamName, username, logoAvatarUrl, plan, subscriptionDaysLeft } = userProfile

  const isUserAdmin = Auth.getPayLoad().isAdmin
  
  const isUserOnTrial = plan.title === '14 day Trial (on Community plan)'

  const isTrialProgressDisplayed = isUserOnTrial && !isSmallSideBar

  const activeItem = location.pathname.split('/')[1]

  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        backgroundColor: '#13165a',
      }}
    >
      <div style={{ flexGrow: 1 }}>
        <Menu borderless vertical inverted fluid style={{ backgroundColor: 'inherit' }}>
          {/* Logo */}
          <Menu.Item style={{ height: '76px' }} onClick={() => goToPage('/projects')}>
            {isSmallSideBar ? (
              <Image src={VloggiSmallLogoWhite} style={{ margin: '5px auto' }} />
            ) : (
              <Image src={VloggiLogoWhite} width="130px" style={{ margin: '5px auto' }} />
            )}
          </Menu.Item>

          {/* User avatar */}
          <Menu.Item onClick={() => goToPage('/my-team')}>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
              <Image avatar style={{ width: isSmallSideBar ? '28px' : '40px', height: isSmallSideBar ? '28px' : '40px' }} src={`${logoAvatarUrl}`} />
              <div>
                <Header as="h4" inverted>
                  {isSmallSideBar ? '' : username}<br />
                  <small>{teamName}</small>
                </Header>
              </div>
            </div>
          </Menu.Item>

          {/* Menu items */}
          {userMenuItems.map((menuItem) => (
            menuItem.page === 'logout' ? (
              <MenuItem
                key={menuItem.name}
                name={menuItem.name}
                icon={menuItem.icon}
                isActive={false}
                isSmallSideBar={isSmallSideBar}
                onClick={logout}
              />
            ) : (
              <MenuItem
                key={menuItem.name}
                name={menuItem.name}
                icon={menuItem.icon}
                isActive={activeItem === menuItem.page}
                isSmallSideBar={isSmallSideBar}
                onClick={() => goToPage(`/${menuItem.page}`)}
              />
            )
          ))}
        </Menu>
      </div>

      <div>
        {isTrialProgressDisplayed && (
          <TrialProgressBar daysLeft={subscriptionDaysLeft} goToPage={goToPage} />
        )}
        {isUserAdmin && (
          <Menu borderless vertical inverted fluid style={{ backgroundColor: 'inherit' }}>
            {/* Admin Menu items */}
            {adminMenuItems.map((menuItem) => (
              <MenuItem
                key={menuItem.name}
                name={menuItem.name}
                icon={menuItem.icon}
                isActive={activeItem === menuItem.page}
                isSmallSideBar={isSmallSideBar}
                onClick={() => goToPage(`/${menuItem.page}`)}
              />
            ))}
          </Menu>
        )}
      </div>
    </div>
  )
}

interface IProps extends RouteComponentProps<any> {
  isSmallSideBar?: boolean
  goToPage: (args: string) => void
}

interface IUserCardProps {
  teamName: string
  username: string
  logoAvatarUrl: string
  isSmallSideBar: boolean
}

export default withRouter(SideBarMain)
